export const brandOverlaySid = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
